import { Price } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSignedIfAdmin } from './fetchFromApi';

export const fetchProductPrice = (productId: string) =>
  fetchFromApiSignedIfAdmin<Price>(
    `${getParams().context}s/${getParams().contextId}/products/${productId}/price`
  );
